import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciButtonComponent } from './luci-button.component';



@NgModule({
  declarations: [LuciButtonComponent],
  exports: [LuciButtonComponent],
  imports: [
    CommonModule
  ]
})
export class LuciButtonModule { }
